import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectors, actions } from '../store/dux/grower-dux';
import { useUrlUpdater } from './use-url-updater';

export function useGrowers() {
  const { updateParams } = useUrlUpdater();
  const dispatch = useDispatch();
  const growers = useSelector(selectors.all);
  const selected = useSelector(selectors.selected);
  const selectedId = useSelector(selectors.selectedId);
  const selectedName = useSelector(selectors.selectedName);
  const organizations = useSelector(selectors.organizations);
  const selectedOrganization = useSelector(selectors.selectedOrganization);

  const selectOrganization = useCallback(
    (organization) => dispatch(actions.setSelectedOrganization(organization)),
    [dispatch],
  );

  const selectGrower = useCallback(
    (guid) => {
      if (guid !== selectedId) {
        const grower = growers?.find((g) => g.guid === guid);
        if (!grower) return;

        dispatch(actions.setSelectedGrowerOperation(grower));
        updateParams({ growerid: grower.guid });

        if (grower.organizationId !== selectedOrganization?.id) {
          selectOrganization(grower.organization);
        }
      }
    },
    [
      dispatch,
      growers,
      selectOrganization,
      selectedId,
      selectedOrganization,
      updateParams,
    ],
  );

  const resetGrowerSelection = useCallback(() => {
    updateParams({ growerid: null });
    dispatch(actions.resetSelectedGrowerOperation());
  }, [dispatch, updateParams]);

  return {
    all: growers,
    selected,
    selectedId,
    selectedName,
    selectGrower,
    organizations,
    selectOrganization,
    selectedOrganization,
    resetGrowerSelection,
  };
}
